<template>
  <el-dialog
      :visible.sync="visible"
      :title="title||'选择加工明细'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="合同编号：">
        <order-drop v-model="dataForm.orderCode" size="mini" placeholder="请输入合同编号进行搜索"></order-drop>
      </el-form-item>
      <el-form-item label="品番号：">
        <el-input v-model="dataForm.productCode" size="mini" placeholder="品番号"/>
      </el-form-item>
      <el-form-item label="品名：">
        <el-input v-model="dataForm.productName" size="mini" placeholder="品名"/>
      </el-form-item>
      <el-form-item label="颜色：">
        <el-input v-model="dataForm.productColor" size="mini" placeholder="颜色"/>
      </el-form-item>
      <el-form-item label="规格：">
        <el-input v-model="dataForm.productSize" size="mini" placeholder="规格"/>
      </el-form-item>
      <el-form-item>
        <el-button @click="$refs.table.reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="dataFormSubmitHandle" size="mini">确定选择</el-button>
      </el-form-item>
    </el-form>
    <make-detail-table :max-table-height="500" :query-form="dataForm" :need-page="true" ref="table"></make-detail-table>
  </el-dialog>
</template>

<script>
import MakeDetailTable from '@/components/MakeDetailTable/index.vue'

export default {
  name: 'MakeDetailDialog',
  components: { MakeDetailTable },
  props: {
    title: {
      type: String,
      default: ''
    },
    customerId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/trade/agreement/detail/list',
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      dataForm: {
        orderCode: '',
        customerId: '',
        productCode:'',
        productName:'',
        productColor:'',
        productSize:''
      },
    }
  },
  watch: {
    customerId: {
      handler: function (newVal) {
        this.dataForm.customerId = newVal
      },
      immediate: true
    }
  },
  methods: {
    clearSelection(){
      if(this.$refs.table){
        this.$refs.table.clearSelection()
      }
    },
    dataFormSubmitHandle () {
      this.$emit('change', this.$clone(this.$refs.table.dataListSelections))
      this.cancel()
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.table.reload()
      })
    },
    cancel () {
      this.visible = false
    },
  },
}
</script>
